export default {
  translation: {
    // header
    Discover: "Découvrir",
    WhyQriend: "Pourquoi QRiend ?",
    LeaveMark: "Laisser une Trace",
    InstallNow: "Installer Maintenant",
    Login: "Connexion",
    Register: "S'inscrire",
    LogOut: "Se Déconnecter",

    // footer
    HomePage: "Page d'Accueil",
    QriendDescFooter: "Découvrez de nouvelles amitiés dans des environnements sociaux, rencontrez de manière sûre et moderne !",
    Pages: "Pages",
    PrivacyAndSecurity: "Confidentialité et Sécurité",
    HomePage: "Accueil",
    QriendTeam: "Notre Équipe",
    PrivacyPolicy: "Politique de Confidentialité",
    TermsOfUse: "Conditions d'Utilisation",
    DataSecurity: "Sécurité des Données",
    CookiePolicy: "Politique des Cookies",
    AccountSecurity: "Sécurité du Compte",
    LegalConsentAndDisclosureText: "Consentement Légal et Texte de Divulgation",
    ChildSafetyPolicy: "Politique de Sécurité des Enfants",
    PrivacySettingsGuide: "Guide des Paramètres de Confidentialité",
    SuitableForAllDevices: "Compatible avec tous les appareils",
    DownloadNowFooter: "Téléchargez maintenant, développez votre réseau social !",

    // delete request
    DeleteRequestTitle: "Demande de suppression de compte",
    DeleteAccountQuestion: "Voulez-vous supprimer votre compte ?",
    Username: "Nom d'utilisateur",
    Password: "Mot de passe",
    DeleteReason: "Pourquoi voulez-vous supprimer votre compte ?",
    UsernamePlaceholder: "Entrez votre nom d'utilisateur",
    PasswordPlaceholder: "Entrez votre mot de passe",
    ReasonPlaceholder: "Expliquez pourquoi vous voulez supprimer votre compte...",
    SubmitDeleteRequest: "Soumettre la demande de suppression",
    Warning: "Attention",
    WarningMessage: "La suppression du compte ne peut pas être annulée. Toutes vos données seront définitivement supprimées.",
    RequestSubmittedSuccessfully: "Demande soumise avec succès",
    RequestSubmittedMessage: "Votre demande de suppression de compte a été reçue. Nous vous répondrons dans les plus brefs délais.",
    SendNewRequest: "Envoyer une nouvelle demande",
    UsernameRequired: "Le nom d'utilisateur est requis",
    PasswordRequired: "Le mot de passe est requis",
    ReasonRequired: "La raison de suppression du compte est requise",

    // register page
    createAccount: "Créer un compte",
    createAccountDesc: "Inscrivez-vous maintenant et commencez à rencontrer de nouvelles personnes !",
    firstname: "Prénom",
    lastname: "Nom",
    username: "Nom d'utilisateur",
    email: "E-mail",
    password: "Mot de passe",
    gender: "Genre",
    male: "Homme",
    female: "Femme",
    noGender: "Préfère ne pas dire",
    registerMain: "S'inscrire",
    registerDesc: "Vous avez déjà un compte ?",
    registerLogin: "Se connecter",
    kvkkConsent: "J'accepte les accords KVKK et de confidentialité",
    kvkkConsentRequired: "Vous devez accepter les accords KVKK et de confidentialité",
    privacyPolicy: "Politique de confidentialité",
    termsOfUse: "Conditions d'utilisation",

    // Landing Qriend Nedir?
    WhatIsQriend: "Qu'est-ce que QRiend ?",
    WhatIsQriendDesc: "Il vous permet de rencontrer des personnes au même endroit grâce à la technologie QR. Il offre une plateforme moderne et sécurisée pour rencontrer de nouvelles personnes dans des espaces sociaux comme les bars, cafés et restaurants.",
    RealProfile: "Profil Réel",
    RealProfileDesc: "Vous n'interagissez qu'avec des utilisateurs réels vérifiés.",
    InstantMeetingOpportunity: "Opportunité de Rencontre Instantanée",
    InstantMeetingOpportunityDesc: "Vous pouvez rencontrer quelqu'un que vous voyez dans le lieu par messagerie instantanée.",
    VenueChats: "Chats de Lieu",
    VenueChatsDesc: "QRiend offre une socialisation numérique dans votre espace.",

    // Landing Nasıl Tanışılır?
    HowtoMeet: "Comment Rencontrer des Gens ?",
    HowtoMeetDesc: "Avec notre application, rencontrer des personnes en temps réel à votre emplacement actuel est maintenant incroyablement facile ! Voici un guide étape par étape sur la façon de l'utiliser ;",
    EntryandConnectiontotheSpace: "Entrer et Se Connecter au Lieu",
    EntryandConnectiontotheSpaceDesc: "Scannez le code QR avec votre téléphone",
    EntryandConnectiontotheSpaceDesc2: "Connectez-vous à l'application pour rejoindre le réseau du lieu",
    InSituExploration: "Exploration Sur Place",
    InSituExplorationDesc: "Voir les autres utilisateurs actuellement dans le lieu",
    InSituExplorationDesc2: "Parcourir les profils qui vous intéressent",
    CommunicationInitiation: "Initiation de la Communication",
    CommunicationInitiationDesc: "Envoyer des messages aux personnes qui attirent votre attention",
    CommunicationInitiationDesc2: "Se connecter facilement avec quelqu'un avec qui vous avez eu un contact visuel",
    CommunicationInitiationDesc3: "Rejoindre la zone de chat de groupe de votre emplacement actuel",
    SafeSocialization: "Socialisation Sûre",
    SafeSocializationDesc: "Apprendre à se connaître par messagerie mutuelle",
    SafeSocializationDesc2: "Vous pouvez contrôler ou terminer la conversation à tout moment",
    SafeSocializationDesc3: "Continuer à rencontrer de nouvelles personnes de manière amusante et sûre",

    // Uygulamayı İndir Bölümü
    DownloadApp: "TÉLÉCHARGEZ L'APPLICATION ET",
    DownloadApp2: "COMMENCEZ À EXPLORER !",
    DownloadAppDesc: "Disponible sur App Store et Google Play !",
    DownloadAppDesc2: "Téléchargez gratuitement,",
    DownloadAppDesc3: "découvrez les fonctionnalités premium.",

    // Discover
    DiscoverTitle: "Plateforme Innovante et Sociale Facilitant les Vraies Rencontres",
    DiscoverDesc: "Êtes-vous fatigué des textos sans fin ? N'aimeriez-vous pas savoir que vous êtes au même endroit que les personnes que vous voulez rencontrer dans la vraie vie ? C'est exactement pourquoi notre application est différente !",
    DiscoverEp2: "Êtes-vous prêt à vérifier votre présence dans nos lieux partenaires avec la technologie QR et à rencontrer de vraies personnes dans le même lieu ?",
    DiscoverEp2Dot: "Suivi des Amitiés",
    DiscoverEp2DotDesc: "Suivez les profils que vous aimez et découvrez leurs endroits préférés. Saisissez l'opportunité de rencontrer de nouveaux endroits et de nouvelles personnes.",
    DiscoverEp3Dot: "J'aime des Profils et Lieux",
    DiscoverEp3DotDesc: "Rencontrez de nouvelles personnes et découvrez vos endroits préférés à travers les profils et lieux que vous aimez.",
    DiscoverEp4Dot: "Rencontre Sur Place",
    DiscoverEp4DotDesc: "Contrairement aux applications de rencontre ordinaires, avec nous tout est réel ! Vous pouvez voir que vous êtes au même endroit que quelqu'un que vous aimez et le rencontrer immédiatement.",
    SwiperText: "Interface Pratique",
    SafetyMeet: "Rencontres Plus Sûres et Plus Amusantes",
    RealTimeInteraction: "Interaction en Temps Réel",
    RealTimeInteractionDesc: "Au lieu de vous perdre dans le monde virtuel, rencontrez des personnes qui sont réellement au même endroit en ce moment",
    RealTimeInteractionDesc2: "Qui est dans votre café préféré ? Voyez instantanément et ne manquez pas l'occasion de rencontrer",
    RealTimeInteractionDesc3: "Grâce à notre technologie QR, vérifiez facilement le lieu où vous vous trouvez",
    SecureAndVerifiedEnvironment: "Environnement Sécurisé et Vérifié",
    SecureAndVerifiedEnvironmentDesc: "Socialisez dans nos lieux partenaires",
    SecureAndVerifiedEnvironmentDesc2: "Avec la vérification de localisation réelle, le risque de faux profil est minimal",
    SecureAndVerifiedEnvironmentDesc3: "Découvrez et partagez vos lieux préférés",
    BenefitsForBusinesses: "Avantages pour les Entreprises",
    BenefitsForBusinessesDesc: "Augmentez votre trafic client",
    BenefitsForBusinessesDesc2: "Créez un environnement avec une interaction sociale élevée",

    // leave-mark
    LeaveMark: "Laissez Votre Trace",
    LeaveMarkTitle: "Laissez Votre Trace : Développez Votre Expérience Sociale et Créez des Connexions lors d'Événements",
    LeaveMarkDesc: "La fonctionnalité 'Laissez Votre Trace' de QRiend vous permet de développer votre expérience sociale lors de concerts, festivals, conférences et de nombreux autres événements. Maintenant, vous pouvez rencontrer de nouvelles personnes non seulement dans les lieux, mais à chaque événement auquel vous participez.",
    How2Use: "Comment Ça Marche ?",
    How2UseDot1: "Rejoignez l'Événement",
    How2UseDot1Desc: "Allez à un concert, festival, conférence ou tout événement",
    How2UseDot1Desc2: "Scannez le code QR spécial QRiend sur le lieu de l'événement",
    How2UseDot1Desc3: "Connectez-vous instantanément au chat de l'événement",
    How2UseDot2: "Découvrez les Participants de l'Événement",
    How2UseDot2Desc: "Voir les autres utilisateurs QRiend participant au même événement",
    How2UseDot2Desc2: "Suivez en temps réel combien de personnes sont actives dans le chat de l'événement",
    How2UseDot2Desc3: "Trouvez des personnes qui partagent vos intérêts",
    How2UseDot3: "Interactions Spéciales",
    How2UseDot3Desc: "Vous pouvez envoyer des emojis spéciaux aux participants qui attirent votre attention",
    How2UseDot3Desc2: "Les emojis envoyés apparaissent dans tout le chat comme 'Utilisateur A a envoyé un emoji cœur à Utilisateur B'",
    How2UseDot3Desc3: "L'envoi d'emojis est une fonctionnalité premium et rend les rencontres lors d'événements plus amusantes",
    WhereCanIUseIt: "Où Puis-je L'utiliser ?",
    WhereCanIUseItDesc: "La façon la plus facile de rencontrer de nouvelles personnes dans différents environnements, des cafés aux concerts, festivals aux restaurants.",
    WhereCanIUseItDot1: "Laissez Votre Trace aux Concerts",
    WhereCanIUseItDot1Desc: "Écrivez quelque chose qui laissera votre trace au concert auquel vous avez assisté.",
    WhereCanIUseItDot2: "Laissez Votre Trace dans les Cafés",
    WhereCanIUseItDot2Desc: "Opportunité de socialiser dans de larges cercles d'amis dans les cafés ou pubs",
    WhereCanIUseItDot3: "Utilisation dans les Bars et Boîtes de Nuit",
    WhereCanIUseItDot3Desc: "Socialisation dans la vie nocturne, soirées à thème et opportunités de rencontre sûres",
    DownloadApp: "Téléchargez l'Application Mobile pour Laisser Votre Trace",

    // downloadPage
    DownloadNowNew: "Téléchargez Maintenant et Commencez",
    DownloadNowNew2: "à Rencontrer de Nouvelles Personnes",
    DownloadNowNew3: "Aujourd'hui !",
    DownloadNowDesc: "Dans chaque lieu où vous allez, rencontrez de nouvelles personnes avec un seul code QR !",
    SupportPlatforms: "Plateformes et Appareils Supportés",
    SupportPlatformsDesc: "Accès de Partout",
    SupportPlatformsDesc2: "Appareils Mobiles",
    SupportPlatformsDescDot: "Application iOS (optimisée pour iPhone et iPad)",
    SupportPlatformsDescDot2: "Application Android (tous les téléphones et tablettes Android)",

    // login ve register
    welcome: "Bienvenue",
    welcomeDesc: "Vous nous avez manqué ! Veuillez vous connecter pour rattraper ce que vous avez manqué.",
    email: "E-mail",
    password: "Mot de Passe",
    forgotPassword: "Mot de passe oublié ?",
    login: "Se Connecter",
    registerMain: "S'inscrire",
    loginDesc: "Vous n'avez pas encore de compte ?",
    loginReg: "S'inscrire",
    createAccount: "Créer un Compte",
    createAccountDesc: "Inscrivez-vous maintenant et commencez à construire de nouvelles amitiés.",
    firstname: "Prénom",
    lastname: "Nom de Famille",
    username: "Nom d'Utilisateur",
    gender: "Genre",
    password: "Mot de Passe (Au moins 6 caractères)",
    register: "S'inscrire",
    registerDesc: "Vous avez déjà un compte ?",
    registerLogin: "Se Connecter",
    rememberMe: "Se Souvenir de Moi",
    male: "Homme",
    female: "Femme",
    noGender: "Préfère ne pas spécifier le genre",

    // Şifre Sıfırlama Onay - forgotPasswordConfirm.js
    passwordReset: "Réinitialiser le Mot de Passe",
    passwordResetDesc: "Veuillez entrer le code à 6 chiffres envoyé à votre adresse e-mail et créer un nouveau mot de passe.",
    verificationCode: "Code de Vérification",
    codeValidityTime: "Durée de Validité du Code",
    newPassword: "Nouveau Mot de Passe",
    newPasswordPlaceholder: "Entrez le nouveau mot de passe",
    confirmPassword: "Confirmer le Mot de Passe",
    confirmPasswordPlaceholder: "Confirmez votre mot de passe",
    resettingPassword: "Réinitialisation du Mot de Passe...",
    resetPasswordButton: "Réinitialiser le Mot de Passe",
    enterVerificationCode: "Entrez le code à 6 chiffres de vérification.",
    passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères.",
    passwordMismatch: "Les mots de passe ne correspondent pas !",
    passwordResetSuccess: "Votre mot de passe a été réinitialisé avec succès !",
    passwordResetError: "Impossible de réinitialiser le mot de passe, veuillez réessayer.",
  },
};